import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class GenericError 
{
    constructor
    (
      private _notifier : NotifierManager
    ) {}

    generic() 
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.GENERIC_ERROR)
    }
}